export default {
  methods: {
    mix_trackNav(navName) {
      if (!navName || !navName.length) {
        return;
      }

      const eventName = `${navName.toLowerCase()}_viewed`;
      this.trackMREvent(eventName);
    },

    mix_trackItemClick(title) {
      const eventName = `Site Nav Click - ${title}`;
      this.trackMREvent(eventName);
    }
  }
};
